import { ChakraText } from "../ChakraText";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const HeaderText = ({ children }: IProps) => {
  return (
    <ChakraText as="h1" fontSize="4xl">
      {children}
    </ChakraText>
  );
};

export { HeaderText };
